var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconControlBarLoginSave = function SvgIconControlBarLoginSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.7,
    fillRule: "evenodd",
    d: "M4 3.027a1 1 0 0 1 .997-1l10-.027A1 1 0 0 1 16 3v14a.5.5 0 0 1-.697.46L10 15.18l-5.303 2.28A.5.5 0 0 1 4 17z",
    clipRule: "evenodd"
  })));
};
export default SvgIconControlBarLoginSave;